import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActiveCartService } from '@cart/data-access';
import { CustomMultiCartService } from '@cart/feature';
import { SdModalService, SdvorButtonComponent } from '@sdvor/shared/ui/v2';
import { DeviceService } from '@shared/services';
import { ButtonThemes } from '@shared/v2';
import { UserIdService } from '@spartacus/core';
import { combineLatest, take } from 'rxjs';

@Component({
  selector: 'sd-cart-clear-confirmation',
  imports: [SdvorButtonComponent],
  templateUrl: './cart-clear-confirmation.component.html',
  styleUrls: ['./cart-clear-confirmation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartClearConfirmationComponent {
  private deviceService = inject(DeviceService);
  private userIdService = inject(UserIdService);
  private modalService = inject(SdModalService);
  private activeCartService = inject(ActiveCartService);
  private customMultiCartService = inject(CustomMultiCartService);

  protected readonly buttonThemes = ButtonThemes;
  protected readonly isMobileSmDown = toSignal(this.deviceService.isMobileSmDown$, { initialValue: false });

  protected removeAllEntries(): void {
    combineLatest({
      userId: this.userIdService.getUserId().pipe(take(1)),
      cartId: this.activeCartService.getActiveCartId().pipe(take(1)),
    }).subscribe(({ userId, cartId }) => this.customMultiCartService.removeAllEntries(userId, cartId));

    this.modalService.closeActiveModal();
  }
}
